import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';
import { LocalStorageService } from './services/local-storage.service';
import { BehaviorSubject } from 'rxjs';
import { PosSpinnerService } from './@core/services/pos-spinner.service';
@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit, AfterViewChecked {
  title = 'frontend-pos-franchised';

  loading: boolean = false;

  constructor(private router: Router,
    public iconSet: IconSetService,
    private localStorageService: LocalStorageService,
    private spinnerService: PosSpinnerService,
    private ref: ChangeDetectorRef) {
    iconSet.icons = { ...freeSet };

    this.spinnerService.loading.subscribe(s => {

      this.loading = s;

    });

  }
  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (evt instanceof NavigationEnd && !evt.url.includes('customer')) {
        this.localStorageService.remove('selectedCustomer');
      }
      window.scrollTo(0, 0);
    });
  }

  ngAfterViewChecked(): void {
    this.ref.detectChanges();
  }
}